// components/onboarding/steps/SuccessRateCardStep.jsx - Accurate Zone-Based Rate Card
import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const SuccessRateCardStep = () => {
  const navigate = useNavigate();
  const [selectedZone, setSelectedZone] = useState('Local');
  const [showInfo, setShowInfo] = useState(false);

  // ACTUAL Rate Card Data from Excel File
  const rateCardData = {
    zones: {
      'Local': {
        icon: '🏙️',
        color: 'from-green-500 to-emerald-600',
        description: 'Within City',
        rates: [
          { weight: '0-500gms', DTDC: 29, Professional: 23, Shadowfax: 26, Delhivery: 28, Amazon: 26, Ekart: 29, Xpressbees: 36, Bluedart: 35 },
          { weight: 'additional 500gm', DTDC: 19, Professional: 19, Shadowfax: 25, Delhivery: 19, Amazon: 23, Ekart: 21, Xpressbees: 29, Bluedart: 30 },
          { weight: '1kg', DTDC: 85, Professional: 49, Shadowfax: 75, Delhivery: 83, Amazon: 83, Ekart: 89, Xpressbees: 86, Bluedart: 118 },
          { weight: 'additional 1kg', DTDC: 38, Professional: 16, Shadowfax: 21, Delhivery: 38, Amazon: 23, Ekart: 5, Xpressbees: 29, Bluedart: 56 },
          { weight: '5kg', DTDC: 196, Professional: 76, Shadowfax: 135, Delhivery: 172, Amazon: 186, Ekart: 93, Xpressbees: 136, Bluedart: 284 },
          { weight: 'additional 1kg (post 5kg)', DTDC: 26, Professional: 13, Shadowfax: null, Delhivery: 29, Amazon: 31, Ekart: 19, Xpressbees: 22, Bluedart: 56 },
          { weight: '10kg', DTDC: 325, Professional: 112, Shadowfax: null, Delhivery: 315, Amazon: 265, Ekart: 186, Xpressbees: 244, Bluedart: 560 },
          { weight: 'additional 1kg (post 10kg)', DTDC: 26, Professional: 12, Shadowfax: null, Delhivery: 19, Amazon: 16, Ekart: 19, Xpressbees: 22, Bluedart: 56 },
        ]
      },
      'Within State': {
        icon: '🏞️',
        color: 'from-blue-500 to-indigo-600',
        description: 'Within State',
        rates: [
          { weight: '0-500gms', DTDC: 36, Professional: 25, Shadowfax: 29, Delhivery: 32, Amazon: 31, Ekart: 35, Xpressbees: 39, Bluedart: 37 },
          { weight: 'additional 500gm', DTDC: 22, Professional: 16, Shadowfax: 26, Delhivery: 22, Amazon: 26, Ekart: 22, Xpressbees: 32, Bluedart: 30 },
          { weight: '1kg', DTDC: 101, Professional: 53, Shadowfax: 83, Delhivery: 96, Amazon: 95, Ekart: 99, Xpressbees: 99, Bluedart: 125 },
          { weight: 'additional 1kg', DTDC: 43, Professional: 18, Shadowfax: 22, Delhivery: 43, Amazon: 36, Ekart: 9, Xpressbees: 32, Bluedart: 59 },
          { weight: '5kg', DTDC: 229, Professional: 83, Shadowfax: 148, Delhivery: 186, Amazon: 212, Ekart: 106, Xpressbees: 151, Bluedart: 301 },
          { weight: 'additional 1kg (post 5kg)', DTDC: 49, Professional: 15, Shadowfax: null, Delhivery: 29, Amazon: 22, Ekart: 22, Xpressbees: 25, Bluedart: 59 },
          { weight: '10kg', DTDC: 472, Professional: 123, Shadowfax: null, Delhivery: 331, Amazon: 301, Ekart: 215, Xpressbees: 272, Bluedart: 595 },
          { weight: 'additional 1kg (post 10kg)', DTDC: 49, Professional: 13, Shadowfax: null, Delhivery: 22, Amazon: 21, Ekart: 22, Xpressbees: 23, Bluedart: 59 },
        ]
      },
      'Metro to Metro': {
        icon: '🌆',
        color: 'from-purple-500 to-pink-600',
        description: 'Metro to Metro',
        rates: [
          { weight: '0-500gms', DTDC: 35, Professional: 29, Shadowfax: 35, Delhivery: 39, Amazon: 38, Ekart: 41, Xpressbees: 46, Bluedart: 47 },
          { weight: 'additional 500gm', DTDC: 41, Professional: 19, Shadowfax: 32, Delhivery: 22, Amazon: 32, Ekart: 23, Xpressbees: 35, Bluedart: 39 },
          { weight: '1kg', DTDC: 176, Professional: 65, Shadowfax: 95, Delhivery: 103, Amazon: 95, Ekart: 109, Xpressbees: 112, Bluedart: 161 },
          { weight: 'additional 1kg', DTDC: 81, Professional: 19, Shadowfax: 23, Delhivery: 43, Amazon: 35, Ekart: 13, Xpressbees: 35, Bluedart: 76 },
          { weight: '5kg', DTDC: 415, Professional: 96, Shadowfax: 164, Delhivery: 201, Amazon: 264, Ekart: 122, Xpressbees: 172, Bluedart: 389 },
          { weight: 'additional 1kg (post 5kg)', DTDC: 98, Professional: 16, Shadowfax: null, Delhivery: 31, Amazon: 16, Ekart: 25, Xpressbees: 28, Bluedart: 76 },
          { weight: '10kg', DTDC: 901, Professional: 139, Shadowfax: null, Delhivery: 351, Amazon: 394, Ekart: 244, Xpressbees: 308, Bluedart: 769 },
          { weight: 'additional 1kg (post 10kg)', DTDC: 98, Professional: 13, Shadowfax: null, Delhivery: 22, Amazon: 23, Ekart: 25, Xpressbees: 28, Bluedart: 76 },
        ]
      },
      'Rest of India': {
        icon: '🗺️',
        color: 'from-orange-500 to-red-600',
        description: 'Rest of India',
        rates: [
          { weight: '0-500gms', DTDC: 58, Professional: 33, Shadowfax: 41, Delhivery: 43, Amazon: 42, Ekart: 45, Xpressbees: 51, Bluedart: 54 },
          { weight: 'additional 500gm', DTDC: 43, Professional: 21, Shadowfax: 35, Delhivery: 23, Amazon: 35, Ekart: 31, Xpressbees: 36, Bluedart: 44 },
          { weight: '1kg', DTDC: 186, Professional: 75, Shadowfax: 111, Delhivery: 112, Amazon: 108, Ekart: 135, Xpressbees: 123, Bluedart: 184 },
          { weight: 'additional 1kg', DTDC: 95, Professional: 25, Shadowfax: 31, Delhivery: 46, Amazon: 59, Ekart: 13, Xpressbees: 38, Bluedart: 87 },
          { weight: '5kg', DTDC: 444, Professional: 118, Shadowfax: 201, Delhivery: 218, Amazon: 298, Ekart: 136, Xpressbees: 189, Bluedart: 443 },
          { weight: 'additional 1kg (post 5kg)', DTDC: 105, Professional: 22, Shadowfax: null, Delhivery: 32, Amazon: 16, Ekart: 28, Xpressbees: 31, Bluedart: 87 },
          { weight: '10kg', DTDC: 966, Professional: 179, Shadowfax: null, Delhivery: 375, Amazon: 394, Ekart: 272, Xpressbees: 339, Bluedart: 874 },
          { weight: 'additional 1kg (post 10kg)', DTDC: 105, Professional: 19, Shadowfax: null, Delhivery: 23, Amazon: 26, Ekart: 28, Xpressbees: 31, Bluedart: 87 },
        ]
      },
      'Special Zone': {
        icon: '⭐',
        color: 'from-indigo-600 to-purple-700',
        description: 'Special Zone',
        rates: [
          { weight: '0-500gms', DTDC: 63, Professional: 41, Shadowfax: 55, Delhivery: 49, Amazon: 55, Ekart: 55, Xpressbees: 58, Bluedart: 71 },
          { weight: 'additional 500gm', DTDC: 48, Professional: 24, Shadowfax: 42, Delhivery: 26, Amazon: 43, Ekart: 33, Xpressbees: 43, Bluedart: 58 },
          { weight: '1kg', DTDC: 205, Professional: 86, Shadowfax: 142, Delhivery: 126, Amazon: 128, Ekart: 143, Xpressbees: 143, Bluedart: 242 },
          { weight: 'additional 1kg', DTDC: 95, Professional: 29, Shadowfax: 33, Delhivery: 52, Amazon: 83, Ekart: 13, Xpressbees: 43, Bluedart: 114 },
          { weight: '5kg', DTDC: 488, Professional: 138, Shadowfax: 241, Delhivery: 278, Amazon: 377, Ekart: 143, Xpressbees: 258, Bluedart: 584 },
          { weight: 'additional 1kg (post 5kg)', DTDC: 113, Professional: 26, Shadowfax: null, Delhivery: 51, Amazon: 33, Ekart: 29, Xpressbees: 36, Bluedart: 114 },
          { weight: '10kg', DTDC: 1053, Professional: 212, Shadowfax: null, Delhivery: 530, Amazon: 394, Ekart: 286, Xpressbees: 437, Bluedart: 1154 },
          { weight: 'additional 1kg (post 10kg)', DTDC: 113, Professional: 23, Shadowfax: null, Delhivery: 26, Amazon: 29, Ekart: 29, Xpressbees: 29, Bluedart: 114 },
        ]
      }
    },
    courierInfo: {
      DTDC: { logo: '/courier_logo/DTDC_logo.png', fullName: 'DTDC' },
      Professional: { logo: null, fullName: 'Professional' },
      Shadowfax: { logo: '/courier_logo/Shadowfax_logo.png', fullName: 'Shadowfax' },
      Delhivery: { logo: '/courier_logo/delhivery_logo.png', fullName: 'Delhivery' },
      Amazon: { logo: null, fullName: 'Amazon' },
      Ekart: { logo: '/courier_logo/ekart_logo.png', fullName: 'Ekart' },
      Xpressbees: { logo: '/courier_logo/xpressbees_logo.png', fullName: 'Xpressbees' },
      Bluedart: { logo: '/courier_logo/bluedart_logo.png', fullName: 'Bluedart' }
    }
  };

  const zones = Object.keys(rateCardData.zones);
  const couriers = ['DTDC', 'Professional', 'Shadowfax', 'Delhivery', 'Amazon', 'Ekart', 'Xpressbees', 'Bluedart'];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="w-full max-w-[1600px] mx-auto px-4"
    >
      {/* Top Dashboard Button */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="flex justify-end mb-4"
      >
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => navigate('/')}
          className="px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-bold rounded-xl shadow-lg hover:shadow-xl transition-all flex items-center gap-2"
        >
          <span>Go to Dashboard</span>
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
          </svg>
        </motion.button>
      </motion.div>

      {/* Success Header */}
      <motion.div
        initial={{ scale: 0.8, y: -50 }}
        animate={{ scale: 1, y: 0 }}
        transition={{ type: 'spring', stiffness: 200 }}
        className="text-center mb-8"
      >
        <div className="relative inline-block mb-6">
          <motion.div
            animate={{
              rotate: [0, -10, 10, -10, 0],
              scale: [1, 1.1, 1, 1.1, 1]
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              repeatDelay: 2
            }}
            className="mx-auto w-32 h-32 bg-gradient-to-br from-yellow-400 via-orange-500 to-red-500 rounded-full flex items-center justify-center shadow-2xl"
          >
            <div className="text-6xl">🔓</div>
          </motion.div>
          <motion.div
            animate={{ scale: [1, 1.5], opacity: [0.5, 0] }}
            transition={{ duration: 2, repeat: Infinity }}
            className="absolute inset-0 bg-yellow-400 rounded-full"
          />
        </div>

        <h1 className="text-5xl md:text-6xl font-black bg-gradient-to-r from-yellow-600 via-orange-600 to-red-600 bg-clip-text text-transparent mb-4">
          🎉 Hurray! You've Unlocked
        </h1>
        <p className="text-3xl text-gray-800 font-bold mb-3">
          Exclusive Onboarding Rates!
        </p>
        <p className="text-sm text-gray-500 italic">
          * Above Rates are Exclusive of GST (18% GST will be included while booking)
        </p>
      </motion.div>

      {/* Sales Contact Banner */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        className="mb-8 bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 rounded-2xl p-6 text-white shadow-2xl"
      >
        <div className="flex items-center justify-center gap-4 flex-wrap">
          <div className="text-3xl">📞</div>
          <div className="text-center md:text-left">
            <p className="text-lg font-bold mb-1">For rate card discussions & customized pricing:</p>
            <div className="flex items-center justify-center md:justify-start gap-6 flex-wrap">
              <a 
                href="tel:8130228919" 
                className="flex items-center gap-2 hover:underline font-semibold"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
                Call: 8130228919
              </a>
              <span className="text-white/50">|</span>
              <a 
                href="mailto:sales@wayuvega.com" 
                className="flex items-center gap-2 hover:underline font-semibold"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
                Email: sales@wayuvega.com
              </a>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Zone Selector */}
      <div className="mb-8">
        <div className="flex items-center justify-center gap-3 flex-wrap mb-4">
          {zones.map((zone) => {
            const zoneData = rateCardData.zones[zone];
            return (
              <button
                key={zone}
                onClick={() => setSelectedZone(zone)}
                className={`px-6 py-3 rounded-xl font-semibold transition-all shadow-lg ${
                  selectedZone === zone
                    ? `bg-gradient-to-r ${zoneData.color} text-white scale-105`
                    : 'bg-white text-gray-700 hover:bg-gray-50'
                }`}
              >
                <span className="text-xl mr-2">{zoneData.icon}</span>
                {zone}
              </button>
            );
          })}
        </div>
      </div>

      {/* Rate Table */}
      <AnimatePresence mode="wait">
        <motion.div
          key={selectedZone}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          className="mb-8 bg-white rounded-3xl shadow-2xl border border-gray-100 overflow-hidden"
        >
          {/* Table Header */}
          <div className={`bg-gradient-to-r ${rateCardData.zones[selectedZone].color} p-6 text-white`}>
            <div className="flex items-center justify-between">
              <div>
                <h2 className="text-3xl font-bold mb-2">
                  {rateCardData.zones[selectedZone].icon} {selectedZone}
                </h2>
                <p className="text-white/90">{rateCardData.zones[selectedZone].description}</p>
              </div>
              <button
                onClick={() => setShowInfo(!showInfo)}
                className="px-4 py-2 bg-white/20 hover:bg-white/30 rounded-lg transition-all"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
          </div>

          {/* Scrollable Table Container */}
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b-2 border-gray-200">
                <tr>
                  <th className="px-4 py-4 text-left text-sm font-bold text-gray-700 sticky left-0 bg-gray-50 z-10">
                    Weight Slab
                  </th>
                  {couriers.map((courier) => (
                    <th key={courier} className="px-4 py-4 text-center text-sm font-bold text-gray-700 min-w-[100px]">
                      <div className="flex flex-col items-center gap-2">
                        {rateCardData.courierInfo[courier].logo ? (
                          <img 
                            src={rateCardData.courierInfo[courier].logo} 
                            alt={courier}
                            className="h-8 w-auto object-contain"
                            onError={(e) => {
                              e.target.style.display = 'none';
                            }}
                          />
                        ) : (
                          <div className="text-xs font-bold text-gray-600">{courier}</div>
                        )}
                        <div className="text-xs text-gray-600">{courier}</div>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rateCardData.zones[selectedZone].rates.map((row, idx) => (
                  <motion.tr
                    key={idx}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: idx * 0.05 }}
                    className={`border-b border-gray-100 hover:bg-blue-50 transition-colors ${
                      row.weight.includes('additional') ? 'bg-yellow-50/50' : ''
                    }`}
                  >
                    <td className="px-4 py-4 font-semibold text-gray-800 sticky left-0 bg-white z-10 text-sm">
                      {row.weight}
                    </td>
                    {couriers.map((courier) => (
                      <td key={courier} className="px-4 py-4 text-center">
                        {row[courier] !== null ? (
                          <span className="inline-flex items-center justify-center px-3 py-1.5 bg-gradient-to-r from-green-50 to-emerald-50 text-green-700 font-bold rounded-lg text-sm border border-green-200">
                            ₹{row[courier]}
                          </span>
                        ) : (
                          <span className="text-gray-400 text-sm">-</span>
                        )}
                      </td>
                    ))}
                  </motion.tr>
                ))}
              </tbody>
            </table>
          </div>
        </motion.div>
      </AnimatePresence>

      {/* COD & RTO Information */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
        className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12"
      >
        {/* COD Handling */}
        <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-2xl p-6 border-2 border-orange-200">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-orange-500 to-red-600 flex items-center justify-center text-white text-2xl flex-shrink-0">
              💵
            </div>
            <div className="flex-1">
              <h3 className="text-xl font-bold text-gray-900 mb-3">COD Charges (Max)</h3>
              <div className="space-y-2">
                <div className="flex items-center justify-between p-3 bg-white rounded-lg">
                  <span className="font-semibold text-gray-700">Fixed Charge:</span>
                  <span className="text-2xl font-black text-orange-600">₹30</span>
                </div>
                <div className="flex items-center justify-between p-3 bg-white rounded-lg">
                  <span className="font-semibold text-gray-700">% of Invoice:</span>
                  <span className="text-2xl font-black text-orange-600">1.5%</span>
                </div>
              </div>
              <p className="mt-3 text-sm text-gray-600 italic">
                * COD charges will be calculated as max(₹30, 1.5% of invoice value)
              </p>
            </div>
          </div>
        </div>

        {/* RTO Charges */}
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-6 border-2 border-blue-200">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white text-2xl flex-shrink-0">
              🔙
            </div>
            <div className="flex-1">
              <h3 className="text-xl font-bold text-gray-900 mb-3">RTO Charges</h3>
              <div className="p-4 bg-white rounded-lg border-2 border-blue-300">
                <div className="text-center">
                  <div className="text-3xl font-black bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-2">
                    Same as Forward
                  </div>
                  <p className="text-sm text-gray-600">
                    RTO charges will be equal to the forward shipping charges
                  </p>
                </div>
              </div>
              <p className="mt-3 text-sm text-gray-600 italic">
                * Return To Origin charges apply when shipment is not delivered
              </p>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Information Panel */}
      <AnimatePresence>
        {showInfo && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="mb-8 bg-gradient-to-r from-indigo-50 to-purple-50 rounded-2xl p-6 border border-indigo-200"
          >
            <h3 className="text-xl font-bold text-gray-900 mb-4">📘 How to Read This Rate Card:</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-gray-700">
              <div className="flex items-start gap-3">
                <div className="text-2xl">1️⃣</div>
                <div>
                  <strong>Weight Slabs:</strong> Rates vary by weight ranges. "Additional" rows show charges for extra weight beyond base slabs.
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="text-2xl">2️⃣</div>
                <div>
                  <strong>Choose Zone:</strong> Select your delivery zone using buttons above. Rates differ by distance.
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="text-2xl">3️⃣</div>
                <div>
                  <strong>Compare Couriers:</strong> Each column shows a different courier partner's rates for easy comparison.
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="text-2xl">4️⃣</div>
                <div>
                  <strong>GST Extra:</strong> All rates shown are exclusive of 18% GST which will be added at booking.
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* CTA Section */}
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.6 }}
        className="relative bg-gradient-to-br from-blue-600 via-purple-600 to-pink-600 rounded-3xl shadow-2xl overflow-hidden p-12 text-center text-white mb-8"
      >
        <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-black/10 rounded-full blur-3xl" />
        
        <div className="relative z-10">
          <motion.div
            animate={{ rotate: [0, 10, -10, 0] }}
            transition={{ duration: 2, repeat: Infinity, repeatDelay: 1 }}
            className="text-7xl mb-6"
          >
            🚀
          </motion.div>
          <h2 className="text-4xl font-black mb-4">Ready to Ship Your First Order?</h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Your dashboard is ready with powerful tools to manage orders, track shipments, and grow your business!
          </p>
          
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => navigate('/')}
            className="group relative px-12 py-6 bg-white rounded-2xl font-black text-2xl shadow-2xl hover:shadow-3xl transition-all overflow-hidden"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-yellow-400 via-orange-400 to-pink-400 opacity-0 group-hover:opacity-20 transition-opacity" />
            <span className="relative flex items-center gap-3 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              <span className="text-3xl">🎯</span>
              Go to Merchant Dashboard
              <svg className="w-8 h-8 text-purple-600 group-hover:translate-x-2 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </span>
          </motion.button>

          <div className="mt-8 flex items-center justify-center gap-6 text-sm flex-wrap">
            <div className="flex items-center gap-2">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>Instant Activation</span>
            </div>
            <div className="flex items-center gap-2">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>8 Courier Partners</span>
            </div>
            <div className="flex items-center gap-2">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>24/7 Support</span>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Help Section */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8 }}
        className="text-center p-6 bg-gray-50 rounded-2xl"
      >
        <p className="text-gray-600 mb-2">Need help getting started?</p>
        <div className="flex items-center justify-center gap-4 flex-wrap">
          <a href="tel:8130228919" className="flex items-center gap-2 text-blue-600 font-semibold hover:underline">
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
            </svg>
            Call: 8130228919
          </a>
          <span className="text-gray-400">|</span>
          <a href="mailto:support@wayuvega.com" className="flex items-center gap-2 text-blue-600 font-semibold hover:underline">
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
              <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
            </svg>
            support@wayuvega.com
          </a>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default SuccessRateCardStep;


